import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AppService {

  private readonly fixViewTrigger$ = new Subject<number>();
  public readonly fixViewRequest$ = this.fixViewTrigger$.asObservable();

  public fixView() {
    this.fixViewTrigger$.next(+moment());
  }

  constructor() {
  }
}
